import { useEffect, useState } from 'react';
import type { Locale } from '../i18n';
import { AppShell } from './AppShell';

function readRoute(): string {
  return window.location.hash.replace(/^#\/?/, '');
}

export function Root() {
  const [locale, setLocale] = useState<Locale>(() =>
    localStorage.getItem('erc-locale') === 'en' ? 'en' : 'ru',
  );
  const [route, setRoute] = useState<string>(readRoute);

  useEffect(() => {
    const onHashChange = () => setRoute(readRoute());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  useEffect(() => {
    document.documentElement.lang = locale;
    localStorage.setItem('erc-locale', locale);
  }, [locale]);

  return <AppShell locale={locale} setLocale={setLocale} route={route} />;
}
